import { useMutation } from '@tanstack/react-query';

import {
  downloadExpiringCreditsReport,
  downloadOutsidePolicyDatesRequestsReport,
  downloadRefundRequestsReport,
  queueMusementBookingsReport,
  queueMusementPayableReport,
} from '~/services/ReportingService';

interface DownloadExpiringCreditsReportParams {
  startAt: string;
  endAt: string;
  minimumCreditsValue: number;
}

interface QueueMusementReportParams {
  startAt: string;
  endAt: string;
  format: 'csv' | 'email';
}

export function useDownloadExpiringCreditsReport() {
  return useMutation({
    mutationFn: async (params: DownloadExpiringCreditsReportParams) => {
      return await downloadExpiringCreditsReport(params);
    },
  });
}

export function useQueueMusementBookingsReport() {
  return useMutation({
    mutationFn: async (params: QueueMusementReportParams) => {
      return await queueMusementBookingsReport(params);
    },
  });
}

export function useQueueMusementPayableReport() {
  return useMutation({
    mutationFn: async (params: QueueMusementReportParams) => {
      return await queueMusementPayableReport(params);
    },
  });
}

interface DateRangeReportParams {
  startAt: string;
  endAt: string;
}

export function useDownloadRefundRequestsReport() {
  return useMutation({
    mutationFn: async (params: DateRangeReportParams) => {
      return await downloadRefundRequestsReport(params);
    },
  });
}

export function useDownloadOutsidePolicyDatesRequestsReport() {
  return useMutation({
    mutationFn: async (params: DateRangeReportParams) => {
      return await downloadOutsidePolicyDatesRequestsReport(params);
    },
  });
}
